
import { CourseData } from "@planetadeleste/vue-mc-learning";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CourseDuration extends Vue {
  @Prop(Object) readonly item!: CourseData;
}
